"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenericDiv = exports.Span = exports.InputType = exports.Label = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Label = _styledComponents.default.label.withConfig({
  componentId: "sc-1z070dx-0"
})(["background:transparent;border:none;outline:none;top:21px;-ms-transform:translateY(-50%);transform:translateY(-50%);position:absolute;overflow:hidden;z-index:-1;transition:all 0.2s linear;&:before{content:'';width:100%;height:5px;position:absolute;bottom:0;left:0;z-index:-1;}"]); // campo input


exports.Label = Label;

var InputType = _styledComponents.default.input.attrs(function (_ref) {
  var type = _ref.type;
  return {
    type: type
  };
}).withConfig({
  componentId: "sc-1z070dx-1"
})(["appearance:none;border:none;outline:none;margin:0px;width:100%;background:transparent;&::placeholder{color:transparent;}"]); // span que contem a mensagem de erro


exports.InputType = InputType;

var Span = _styledComponents.default.div.withConfig({
  componentId: "sc-1z070dx-2"
})(["font-size:12px;height:28px;overflow:hidden;color:#f83333;transform:translateY(4px);width:100%;text-rendering:optimizeLegibility;transition:0.2s all linear;padding-left:4px;"]);

exports.Span = Span;

var GenericDiv = _styledComponents.default.div.attrs(function (_ref2) {
  var bgColor = _ref2.bgColor,
      color = _ref2.color,
      borderColor = _ref2.borderColor,
      dark = _ref2.dark,
      icon = _ref2.icon,
      margins = _ref2.margins,
      textColor = _ref2.textColor,
      theme = _ref2.theme,
      mode = _ref2.theme.input.mode;
  return {
    m: {
      t: theme.margin[margins.t],
      r: theme.margin[margins.r],
      b: theme.margin[margins.b],
      l: theme.margin[margins.l]
    },
    left: icon ? theme.margin.lg : theme.margin.xs,
    paddingLeft: icon && 'padding-left:' + theme.margin.lg || '',
    colorTheme: dark ? 'dark' : 'light',
    colors: {
      background: theme.color[bgColor] || theme.color.neutral0,
      borderColor: theme.color[borderColor] || theme.color.primary,
      colorPrimary: theme.color.primary,
      colorError: theme.color.danger,
      colorSuccess: theme.color.success,
      light: {
        color: theme.color[color + [mode.light.color]],
        hover: theme.color[color + [mode.light.hover]],
        label: theme.color[color + [mode.light.label]],
        textColor: theme.color[textColor] || theme.color[mode.light.textColor]
      },
      dark: {
        color: theme.color[color + [mode.dark.color]],
        hover: theme.color[color + [mode.dark.hover]],
        label: theme.color[color + [mode.dark.label]],
        textColor: theme.color[textColor] || theme.color[mode.dark.textColor]
      }
    }
  };
}).withConfig({
  componentId: "sc-1z070dx-3"
})(["position:relative;transition:0.2s all linear;box-sizing:border-box;z-index:1;", ""], function (_ref3) {
  var borderColor = _ref3.borderColor,
      focus = _ref3.focus,
      floatingMessage = _ref3.floatingMessage,
      theme = _ref3.theme,
      left = _ref3.left,
      m = _ref3.m,
      colors = _ref3.colors,
      paddingLeft = _ref3.paddingLeft,
      colorTheme = _ref3.colorTheme;
  return "\n    border-radius: ".concat(theme.borderRadius, ";\n    background: ").concat(colors.background, ";\n    margin: ").concat(m.t, " ").concat(m.r, " ").concat(m.b, " ").concat(m.l, ";\n\n    & ").concat(Label, " {\n      font-family: ").concat(theme.typography.fontFamily[0], ";\n      font-weight: ").concat(theme.typography.fontWeight, ";\n      font-size: ").concat(theme.typography.fontSize, ";\n      line-height:").concat(theme.typography.lineHeight, ";\n      left: ").concat(left, ";\n      color: ").concat(colors[colorTheme].label, ";\n\n      &:before {\n        background: ").concat(colors.background, ";\n      }\n    }\n\n    & ").concat(InputType, " {\n      border-radius: ").concat(theme.borderRadius, ";\n      font-family: ").concat(theme.typography.fontFamily[0], ";\n      font-weight: ").concat(theme.typography.fontWeight, ";\n      font-size: ").concat(theme.typography.fontSize, ";\n      line-height: ").concat(theme.typography.lineHeight, ";\n      box-sizing: border-box;\n      padding: ").concat(theme.input.padding, ";\n      height: ").concat(theme.input.height, ";\n      border: 1px solid ").concat(focus ? colors.colorPrimary + " !important" : colors[colorTheme].color, ";\n      ").concat(paddingLeft, ";\n      color: ").concat(colors[colorTheme].textColor, ";\n\n      &:-webkit-autofill,\n      &:-webkit-autofill:hover,\n      &:-webkit-autofill:focus {\n        -webkit-text-fill-color: ").concat(colors[colorTheme].textColor, ";\n      }\n\n      &:focus + label {\n        color: ").concat(colors.colorPrimary, " !important;\n      }\n\n      &:focus + label,\n      &:not(:placeholder-shown) + label {\n        top: -1px;\n        left:").concat(theme.margin.xxs, ";\n        font-size: ").concat(theme.input.label.focus.fontSize, ";\n        line-height: ").concat(theme.input.label.focus.lineHeight, ";\n        padding: 0px 2px;\n        z-index: 1;\n      }\n\n      &:not(:placeholder-shown) + label {\n        color: ").concat(borderColor ? colors.borderColor : colors[colorTheme].color, ";\n      }\n    }\n\n    & ").concat(Span, " {\n      font-family: ").concat(theme.typography.fontFamily[0], ";\n      opacity: 0;\n      position: ").concat(floatingMessage ? 'absolute' : 'relative', ";\n    }\n\n    & .input-icon svg {\n      fill: ").concat(colors[colorTheme].color, ";\n    }\n\n    &:hover ").concat(InputType, "{\n      border-color: ").concat(colors[colorTheme].hover, ";\n      & .input-icon svg {\n        fill: ").concat(colors[colorTheme].textColor, ";\n      }\n    }\n\n    &:focus-within > .input-icon svg {\n      fill: ").concat(colors.colorPrimary, " !important;\n    }\n\n    &.success {\n      ").concat(InputType, " {\n        border: 1px solid ").concat(colors.colorSuccess, " !important;\n      }\n\n      .input-icon svg {\n        fill: ").concat(colors.colorSuccess, " !important;\n      }\n\n      label {\n        color: ").concat(colors.colorSuccess, " !important;\n      }\n    }\n\n    &.error {\n      ").concat(InputType, " {\n        border: 1px solid ").concat(colors.colorError, " !important;\n      }\n\n      .input-icon svg {\n        fill: ").concat(colors.colorError, " !important;\n      }\n\n      label {\n        color: ").concat(colors.colorError, " !important;\n      }\n\n      ").concat(Span, " {\n        color: ").concat(colors.colorError, " !important;\n        opacity: 1;\n      }\n    }\n\n    & > .input-icon {\n      position: absolute;\n      top: 21px;\n      -ms-transform: translateY(-50%);\n      transform: translateY(-50%);\n      left: ").concat(theme.margin.xs, ";\n      line-height: 1em;\n    }\n  ");
});

exports.GenericDiv = GenericDiv;